import { clubRepositoryKey } from '@/fairplayer/domain/club/ClubRepository';
import { Fan } from '@/fairplayer/domain/fan/Fan';
import { fanRepositoryKey } from '@/fairplayer/domain/fan/FanRepository';
import { KycStepperVue } from '@/fairplayer/primary/kyc-stepper';
import { PageVue } from '@/fairplayer/primary/page';
import { inject, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { KycStatus } from '@/fairplayer/domain/fan/KycStatus';

export default {
  name: 'KycForm',

  components: {
    KycStepperVue,
    PageVue,
  },

  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const clubRepository = inject(clubRepositoryKey)!;
    const fanRepository = inject(fanRepositoryKey)!;
    const fan = ref<Fan>();

    const club = clubRepository.getCurrentClub();

    onMounted(() => retrieveFan());

    const retrieveFan = async () => {
      fan.value = await fanRepository.getForClub(club);
    };

    const goToProfile = () => router.push({ name: 'profile' });

    const resetFanStatusTo = (kycStatus: KycStatus) => {
      fan.value = {
        ...fan.value!,
        kycStatus,
      };
    };

    return {
      resetFanStatusTo,
      fan,
      goToProfile,
      t,
    };
  },
};
